import React, { useEffect, useRef } from 'react';
import { useCompanySettings } from '../hooks/useCompanySettings';
import { useCurrency } from '../contexts/CurrencyContext';

// Component to sync currency context with company settings
export const CurrencySyncProvider = ({ children }) => {
  const { settings: companySettings, loading: settingsLoading } = useCompanySettings();
  const { changeCurrency, selectedCurrency } = useCurrency();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!settingsLoading && companySettings?.defaultCurrency && !hasInitialized.current) {
      const companyCurrency = companySettings.defaultCurrency;
      
      // Only sync on initial load, not on every change
      if (companyCurrency !== selectedCurrency) {
        console.log(`Initial currency sync: ${selectedCurrency} -> ${companyCurrency}`);
        changeCurrency(companyCurrency);
        hasInitialized.current = true;
      }
    }
  }, [settingsLoading, companySettings, changeCurrency, selectedCurrency]);

  return <>{children}</>;
};
